<nav class="navbar navbar-light bg-white fixed-top">
  <ul class="nav navbar-nav mr-auto float-left">
    <li class="nav-item d-none d-md-block">
      <a class="navbar-brand" [routerLink]="inicio.path" [queryParams]="inicio.query">
        <img src="../../assets/logos/logo-corto.png" width="44" height="45" class="d-inline-block align-top" alt="" />

      </a>
    </li>
    @if (header) {
      <li class="nav-item d-none d-md-block">
        <a class="navbar-brand" [routerLink]="[header.link]">
          <span class="navbar-brand-title"><i class="inp-btn {{ header.icon }}"></i>{{ header.name }}</span>
        </a>
      </li>
    }
    @if (header?.visible) {
      <li class="nav-item d-none d-md-block">
        <a *ngxPermissionsOnly="['flows.menu.analytics','flows.admin']" class="navbar-brand"
          [routerLink]="['/legal-analytics']">
          <span class="navbar-brand-subtitle"><i class="inp-btn inp-icon-legal-analytics-o"></i>Legal
        Analytics</span>
      </a>
    </li>
  }
    <li class="nav-item d-none d-md-block">
      <span class="navbar-brand">
        <span class="navbar-brand-subtitle navbar-brand-powered">
          <app-powered-by></app-powered-by>
        </span>
      </span>
    </li>
</ul>
<ul class="nav navbar-nav float-right">
  <li class="d-flex align-items-center mr-4">
    <app-suite-switch ubicacion="header"></app-suite-switch>
  </li>
  <li class="d-flex align-items-center mr-5">
    <a [href]="academiaUrl" target="_blank" class="text-link">
      Tutoriales
    </a>
    <span class="badge-nuevo px-3 py-1">NUEVO</span>
  </li>
  @if (dataUser) {
    <li nclass="nav-item">
      <div class="dropdown-profile">
        <div class="dropdown-profile-user">
          <span class="dropdown-profile-username">{{
            dataUser ? dataUser.name : ""
          }}</span>
          <span class="dropdown-profile-userjob"><i class="inp-icon inp-icon-supervisor-o"></i>{{ dataUser ?
        dataUser.profilename : "" }}</span>
      </div>
      <app-avatar-photo [photoUrl]="undefined" [name]="dataUser.name"></app-avatar-photo>
    </div>
  </li>
}
<li nclass="dropdown-options nav-item dropdown">
  <button class="btn btn-ouline dropdown-toggle" type="button" id="navbarDropdownMenuLink" role="button"
    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <span class="inp-btn inp-icon-menu"></span>
  </button>
  <ul class="dropdown-menu account-menu py-0" role="menu" aria-label="Cuenta" aria-labelledby="navbarDropdownMenuLink">
    @if (shell.cara === 'classic') {
      <li class="dropdown-item px-0 py-0">
        <div class="form-group text-center navbar-interior d-flex justify-content-center">
          @for (btn of moduleVisible; track btn) {
            @if (btn.disabled ? true : btn.visible) {
              <app-centered-menu-btn [isdisabled]="btn.disabled"
                [btnClass]="'btn btn-float btn-blue-lines gap_fl_btn'" [btnName]="btn.alias"
                [btnIcon]="btn.iconClass || ('inp-btn inp-icon-'+ btn.name)" [btnLink]="btn.link">
              </app-centered-menu-btn>
            }
          }
        </div>
      </li>
    }
    <li class="dropdown-item px-0 py-0">
      <ul class="list-group">
        @for (option of navbarMenu; track option) {
          <li class="list-group-item">
            <div *ngxPermissionsOnly="option.permission">
              @if (!option.href && option.clickevent === 'modalOpenUserManage(changePassword)') {
                <div
                  (click)="modalOpenUserManage(changePassword)" class="list-group-text">
                  <span [class]="option.class">@if (option.icon) {
                    <i [class]="option.icon"></i>
                  }</span>
                  {{option.name}}
                </div>
              }
            </div>
            <div *ngxPermissionsOnly="option.permission">
              @if (!option.href && option.clickevent === 'modalOpenUserManage(report)') {
                <div
                  (click)="modalOpenUserManage(report)" class="list-group-text">
                  <span [class]="option.class">@if (option.icon) {
                    <i [class]="option.icon"></i>
                  }</span>
                  {{option.name}}
                </div>
              }
            </div>
            <div *ngxPermissionsOnly="option.permission">
              @if (!option.href &&  option.clickevent === 'modalOpenReport()') {
                <div (click)="modalOpenReport()"
                  class="list-group-text">
                  <span [class]="option.class">@if (option.icon) {
                    <i [class]="option.icon"></i>
                  }</span>
                  {{option.name}}
                </div>
              }
            </div>
            <div *ngxPermissionsOnly="option.permission">
              @if (option.href && !option.clickevent) {
                <a [routerLink]="option.href" class="list-group-text">
                  <span [class]="option.class">@if (option.icon) {
                    <i [class]="option.icon"></i>
                  }</span>
                  {{option.name}}
                </a>
              }
            </div>
          </li>
        }
        <li class="list-group-item" *ngxPermissionsOnly="['flows.menu.perfil.switch.notifications', 'flows.admin']">
          <div class="list-group-text d-flex justify-content-between align-items-center">
            <span>
              <span><i class="fas fa-bell"></i></span>
              Notificaciones
            </span>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="notificationsSwitch"
                [checked]="notificationsEnabled"
                (change)="toggleNotifications($event)">
              <label class="custom-control-label" for="notificationsSwitch"></label>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div (click)="openLinkOAuth()" class="list-group-text" style="cursor:pointer">
            <span><i class="fas fa-link"></i></span>
            Vincular cuentas
          </div>
        </li>
        <li class="list-group-item" *ngIf="imageIntakeEnabled">
          <div *ngxPermissionsOnly="['trackvision.requirement.create','flows.admin']"
               (click)="openImageIntakeModal()" class="list-group-text" style="cursor:pointer"
               title="Crear un requerimiento desde una foto o PDF del parte">
            <span><i class="fas fa-camera"></i></span>
            Crear desde imagen
          </div>
        </li>
        <li class="list-group-item">
          <a [href]="academiaUrl" target="_blank" class="list-group-text">
            <span class="inp-icon inp-icon-clauses"></span>
            Tutoriales
          </a>
        </li>
        <li class="dropdown-divider"></li>
        <li class="list-group-item danger">
          <a [routerLink]="['/login']" (click)="authService.logout()" class="list-group-text">
            <span class="inp-icon inp-icon-logout-o"></span>
            Cerrar Sesión
          </a>
        </li>
      </ul>
    </li>
  </ul>
</li>
</ul>
<ng-template #changePassword let-modal>
  <div class="modalBase w-100">
    <span class="btn_Close" (click)="modal.dismiss('Cross click')"><i class="fas fa-times-circle"></i></span>
    <app-service-modal-change-password></app-service-modal-change-password>
  </div>
</ng-template>
<ng-template #report let-modal>
  <div class="modalBase w-100">
    <span class="btn_Close" (click)="modal.dismiss('Cross click')"><i class="fas fa-times-circle"></i></span>
    <app-admin-report-modal></app-admin-report-modal>
  </div>
</ng-template>
</nav>